import { NgModule } from '@angular/core';
import { GCCoreModule } from '@core/_core.module';
import { AddOrgAddressComponent } from './add-org-modal-pages/add-org-address/add-org-address.component';
import { AddOrgConfirmationComponent } from './add-org-modal-pages/add-org-confirmation/add-org-confirmation.component';
import { AddOrgDetailsComponent } from './add-org-modal-pages/add-org-details/add-org-details.component';
import { AddOrgIdLookupComponent } from './add-org-modal-pages/add-org-id-lookup/add-org-id-lookup.component';
import { AddOrgModalComponent } from './add-org-modal/add-org-modal.component';
import { OrgNotEligibleModalComponent } from './org-not-eligible-modal/org-not-eligible-modal.component';

@NgModule({
  imports: [
    GCCoreModule
  ],
  declarations: [
    AddOrgModalComponent,
    AddOrgIdLookupComponent,
    AddOrgDetailsComponent,
    AddOrgAddressComponent,
    AddOrgConfirmationComponent,
    OrgNotEligibleModalComponent
  ],
  exports: [
    AddOrgModalComponent
  ]
})
export class AddOrganizationModule {}
